module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_9.298e33cb.jpg";